import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { answerWithImageType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderRadioLikeButtonGroupWithImage } from '../../views/RadioLikeButtonGroupWithImage';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

import RoofInclination20PngPath from 'Images/me/pages/guest/proposals/new/roof_inclination/20.png'
import RoofInclination20WebPPath from 'Images/me/pages/guest/proposals/new/roof_inclination/20.webp'
import RoofInclination30PngPath from 'Images/me/pages/guest/proposals/new/roof_inclination/30.png'
import RoofInclination30WebPPath from 'Images/me/pages/guest/proposals/new/roof_inclination/30.webp'
import RoofInclination40PngPath from 'Images/me/pages/guest/proposals/new/roof_inclination/40.png'
import RoofInclination40WebPPath from 'Images/me/pages/guest/proposals/new/roof_inclination/40.webp'

const SECTION_KEY_NAME = 'roofInclination';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'roofSlope';

const textContentsTemplate = (text: string, subText: string) => (
  <span css={css`display: inline-block; height: 2lh;`}>
    {text}<br />
    {subText}
  </span>
);

export const roofInclinationSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: answerWithImageType[] = [
    {
      value: 'なだらかな傾斜(20度)',
      textContents: textContentsTemplate('なだらかな傾斜', '(20度)'),
      imagePaths: {
        imagePath: RoofInclination20PngPath,
        webp: RoofInclination20WebPPath,
      }
    },
    {
      value: '標準的な傾斜(30度)',
      textContents: textContentsTemplate('標準的な傾斜', '(30度)'),
      imagePaths: {
        imagePath: RoofInclination30PngPath,
        webp: RoofInclination30WebPPath,
      }
    },
    {
      value: '急な傾斜(40度)',
      textContents: textContentsTemplate('急な傾斜', '(40度)'),
      imagePaths: {
        imagePath: RoofInclination40PngPath,
        webp: RoofInclination40WebPPath,
      }
    },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '屋根の傾斜は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: (
      <>
        屋根の傾斜はどちらになりますか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderRadioLikeButtonGroupWithImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
